import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'ClosePreviewComponent',
  emits: ['close-viewer-event'],
  setup(__props, { emit }) {

const { t } = useI18n()

const texts = {
  close: t('components.pdf_viewer.close_document') as string
}

// EVENTS


// METHODS
function closeViewerEvent() {
  emit('close-viewer-event')
}

return { __sfc: true,t, texts, emit, closeViewerEvent }
}

})